import React from 'react';
const Iframe = (props) => {
   let iframe_ref = null;
   const resizeIframe = (frame) => {
     const doc = frame?.contentWindow?.document;
     const body = doc?.body;
     const html = doc?.documentElement;

     if (!body || !html) {
       return;
     }

     const height = Math.max(
       body.scrollHeight,
       body.offsetHeight,
       html.clientHeight,
       html.scrollHeight,
       html.offsetHeight
     );

     frame.style.height = `${height}px`;
   };

   const writeHTML = (frame) => {
   if (!frame) {
     return;
   }
   iframe_ref = frame;
   let doc = frame.contentDocument;
   if (doc) {
     doc.open();
     doc.write(props.content);
     doc.close();
     frame.style.width = '100%';
     resizeIframe(frame);

     frame.contentWindow.addEventListener('load', () => resizeIframe(frame));
     setTimeout(() => resizeIframe(frame), 300);
     setTimeout(() => resizeIframe(frame), 1000);
   }
 };
 return (
  <iframe id="ifrmaPreview" src="about:blank" scrolling="no" frameBorder="0" ref={writeHTML} width="100%"/>
 );
};
export default Iframe;
